export default "__VITE_ASSET__ee7041c6__"